const SET_TYPES = (state, types) => {
  state.types = types.map(item => {
    return {
      ...item,
      icon: item.type.toLowerCase(),
      value: false,
    };
  });
};

const SET_CURRENT = (state, current) => {
  state.current = current;
};

export default {
  SET_TYPES,
  SET_CURRENT,
};
